export default "__VITE_PUBLIC_ASSET__8a2af282__"